import { ThemeColors } from '../../../'

export interface BannerButtonColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
  }
}

export const bannerButtonColors: BannerButtonColors = {
  Background: {
    Default: {
      default: 'bg.panel',
    },
    Hover: {
      default: 'overlay.medium',
    },
  },
}
